import { Loader } from "@commonlibs";
import clsx from "clsx";
import { UploadLoadingRoot } from "./UploadLoading.styles";

export interface UploadLoadingProps {
    className?: string;
    style?: React.CSSProperties;
    size?: "sm" | "md";
}

const UploadLoading = ({ className, style, size }: UploadLoadingProps) => {
    return (
        <UploadLoadingRoot alignItems="center" justifyContent="center" className={clsx("upload-loading", className, size)} style={style}>
            <Loader />
        </UploadLoadingRoot>
    );
};

export default UploadLoading;
